var _rect, _ellipse, _ellipse2, _ellipse3, _rect2, _path, _path2, _path3, _circle, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path4, _path5, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnySnail3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#C8B984"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 100,
    ry: 60,
    fill: "#95A882"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 80,
    rx: 150,
    ry: 50,
    fill: "#7D9068"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380,
    cy: 120,
    rx: 100,
    ry: 70,
    fill: "#8A9B72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 230,
    width: 400,
    height: 70,
    fill: "#9C5F2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,260 L50,240 L100,260 L150,240 L200,260 L250,240 L300,260 L350,240 L400,260",
    fill: "none",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200,220 C260,210 310,210 350,220 L350,250 C290,245 240,245 200,250 Z",
    fill: "#FDEBD0",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200,220 C190,200 200,180 220,180 C240,180 250,200 240,220",
    fill: "#FDEBD0",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 180,
    r: 60,
    fill: "#D35400",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 45,
    ry: 36,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 32,
    ry: 25,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 20,
    ry: 16,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 10,
    ry: 8,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220,185 C215,175 210,170 205,175",
    stroke: "#F39C12",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240,185 C245,175 250,170 255,175",
    stroke: "#F39C12",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205,
    cy: 175,
    rx: 8,
    ry: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 175,
    rx: 8,
    ry: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205,
    cy: 175,
    rx: 3,
    ry: 2,
    fill: "black"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 175,
    rx: 3,
    ry: 2,
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197,172 C201,168 209,168 213,172",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M247,172 C251,168 259,168 263,172",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215,210 C225,207 235,207 245,210",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275,235 L290,235 L287,245 L278,245 Z",
    fill: "#F5EEF8",
    stroke: "#7D3C98",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M290,240 L295,240 C295,240 295,235 290,235",
    fill: "none",
    stroke: "#7D3C98",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M279,230 L288,230 L290,235 L277,235 Z",
    fill: "#7D3C98",
    stroke: "#7D3C98",
    strokeWidth: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M281,235 L286,245",
    fill: "none",
    stroke: "#7D3C98",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283,225 C283,223 285,222 285,220",
    stroke: "#7D3C98",
    strokeWidth: 1,
    fill: "none",
    strokeDasharray: "1,1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M286,225 C286,222 288,220 288,217",
    stroke: "#7D3C98",
    strokeWidth: 1,
    fill: "none",
    strokeDasharray: "1,1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnySnail3);
export default __webpack_public_path__ + "static/media/funny-snail3.11c737410d924e9ba0dc3111a6a80242.svg";
export { ForwardRef as ReactComponent };